import config from '../Config';

export function makeKazooRequest(service, authToken, accountId, path = '', post) {
  path = `${accountId ? 'accounts/' + accountId : ''}${path}`;
  return fetch(`${config[service.toUpperCase()+'_API_URL']}${path}`, {
    method: post ? 'POST' : 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-Auth-Token': authToken
    },
  }).then(resp => {
    // Handle auth expired
    if (resp.status === 401) {
      localStorage.setItem(service + '_auth_token', '');
      localStorage.setItem(service + '_account_id', ''); // Clear auth token and auth account id
      return Promise.reject();
    }
    return resp.json();
  }).then(json => json.data)
    .catch(() => {}); // TODO: Handle failed to make request
}
